"use client";

import { Accordion } from "@/components/ui/accordion";
import { UmrahDurationFilter } from "./umrah-duration-filter";
import { UmrahGroupSizeFilter } from "./umrah-group-size-filter";
import { UmrahNameFilter } from "./umrah-name-filter";
import { UmrahPriceRangeFilter } from "./umrah-price-range-filter";

export function UmrahFilterSection() {
  return (
    <Accordion
      className="space-y-2 py-2"
      type="multiple"
      defaultValue={[
        "umrah_name",
        "price",
        "duration",
        "group_size",
      ]}
    >
      <UmrahNameFilter />
      <UmrahPriceRangeFilter />
      <UmrahDurationFilter />
      <UmrahGroupSizeFilter />
    </Accordion>
  );
}
